import { render, staticRenderFns } from "./TwBasePagination.vue?vue&type=template&id=2b78711b"
import script from "./TwBasePagination.vue?vue&type=script&lang=js"
export * from "./TwBasePagination.vue?vue&type=script&lang=js"
import style0 from "./TwBasePagination.vue?vue&type=style&index=0&id=2b78711b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports